'use client'

import { Skeleton as SkeletonMain } from "@/components/ui/skeleton"

export default function Skeleton({ ...props }) {
  return <SkeletonMain {...props} />
}